import { IModuleRegistryItem } from 'layout/registry-layout-get.js';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { ConfigWithDataUrl } from './dataUrlHook.js';

export interface IDataUrlProps {
  debug?: boolean;
  children: IModuleRegistryItem | React.FC<Record<string, unknown>>;
  childModuleName: string;
}

/** Check if module config has a data url */
export const hasConfigDataUrl = (config: IModuleConfig): config is ConfigWithDataUrl => {
  const dataUrl = config.dataUrl;
  if (dataUrl && dataUrl.length > 0) {
    return true;
  }

  return false;
};

// /** Place Holder Module To Be Used for Testing */
// export function PlaceHolderDataUrlMain(props: IModule & IDataUrlProps) {
//   if (hasConfigDataUrl(props.config)) {
//     return <DataUrlComponent {...props} config={props.config} />;
//   }

//   return <RenderSuspenseComponent {...props} />;
// }
